export const withMeasuredDSMBias = (currentParams, bias, dsmOffset) => {
  if (bias === null || bias === undefined || bias === '' || typeof bias === 'boolean') return null;
  const measuredBias = Number(bias);
  if (!Number.isFinite(measuredBias)) return null;

  const { biasSource: _discardFallbackMarker, ...params } =
    currentParams && typeof currentParams === 'object' && !Array.isArray(currentParams) ? currentParams : {};
  return {
    ...params,
    biasSource: 'measured',
    bias: measuredBias,
    dsmOffset
  };
};
